@if (isVisible | async) {
  <a class="d-flex flex-row"
    [tabIndex]="-1"
    [routerLink]="[searchLink]"
    [queryParams]="addQueryParams$ | async"
    (click)="announceFilter(); filterService.minimizeAll()">
    <label class="mb-0 d-flex w-100">
      <input type="checkbox" [checked]="false" class="my-1 align-self-stretch filter-checkbox" role="checkbox" tabindex="0"/>
      <span class="w-100 ps-1 break-facet">
        <span class="float-end badge bg-secondary rounded-pill mt-1 ms-1">{{filterValue.count | dsShortNumber}}</span>
        {{ 'search.filters.' + filterConfig.name + '.' + filterValue.value | translate: {default: filterValue.value} }}
      </span>
    </label>
  </a>
}
